import {
	ACORN_INSTALMENT_CONFIRMATION_WORDING,
	MOTORCADE_INSTALMENT_CONFIRMATION_WORDING,
	CARROT_INSTALMENT_CONFIRMATION_WORDING,
	FLAG_INSTALMENT_CONFIRMATION_WORDING,
	MYPOLICY_INSTALMENT_CONFIRMATION_WORDING,
	STREET_COVER_INSTALMENT_CONFIRMATION_WORDING,
} from '@acorn-portal/shared/src/utils/constants/index';

const getFinanceWording = (company: string) => {
	switch (company.toUpperCase()) {
		case 'ACORN':
			return ACORN_INSTALMENT_CONFIRMATION_WORDING;
		case 'MOTORCADE':
			return MOTORCADE_INSTALMENT_CONFIRMATION_WORDING;
		case 'CARROT':
			return CARROT_INSTALMENT_CONFIRMATION_WORDING;
		case 'FLAG':
			return FLAG_INSTALMENT_CONFIRMATION_WORDING;
		case 'MYPOLICY':
			return MYPOLICY_INSTALMENT_CONFIRMATION_WORDING;
		case 'STREETCOVER':
			return STREET_COVER_INSTALMENT_CONFIRMATION_WORDING;
		default:
			return ACORN_INSTALMENT_CONFIRMATION_WORDING;
	}
};

export default getFinanceWording;
